import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ab9723"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-card" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          (_ctx.icon != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.icon.length <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: _ctx.icon
                    }, null, 8, ["icon"]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
          _hoisted_5,
          (_ctx.hasRemove)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 1,
                icon: "fa-solid fa-xmark",
                onClick: _ctx.removeCard
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}